import*as r from"react";import a from"@mui/material/Step";export*from"@mui/material/Step";const d=r.forwardRef(function(e,o){const{disabled:t,...f}=e;return r.createElement(a,{disabled:!!t,ref:o,...f})});export{d as default};
